import { render, staticRenderFns } from "./ResourceCreator.vue?vue&type=template&id=87c0c570&scoped=true&"
import script from "./ResourceCreator.vue?vue&type=script&lang=js&"
export * from "./ResourceCreator.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCreator.vue?vue&type=style&index=0&id=87c0c570&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c0c570",
  null
  
)

export default component.exports